export default "__VITE_PUBLIC_ASSET__cbfbc0e5__"